import {
  WALLET_SET
} from '../../types';
import {genWallet} from '../../helpers/simpleWallet';
import {wallet as NeonWallet} from "@cityofzion/neon-js";

const bitcoinSecp256r1 = require("bitcoinjs-lib-secp256r1");

const bip39 = require('bip39')

var cryptography = require('@liskhq/lisk-cryptography');
const WavesAPI = require('@waves/waves-api');


export function genAllWallet(mnem, done){
  return async function(dispatch,getState) {
    try {
      let gen = await genWallet(mnem)
      let mnemonic = gen.btcWallet.mnemonic

      let wallet = {}

      //btc
      wallet['btc'] = gen.btcWallet
      wallet.privateKey = gen.btcWallet.privateKeyWF

      //eth, usdt, dai
      wallet['eth'] = gen.ethWallet
      wallet['usdt'] = gen.ethWallet
      wallet['dai'] = gen.ethWallet

      //lsk
      let address = cryptography.getAddressFromPassphrase(mnemonic);
      wallet['lsk'] = {address,privateKey:mnemonic}

      //wav
      const Waves = WavesAPI.create(WavesAPI.MAINNET_CONFIG);
      const seed = Waves.Seed.fromExistingPhrase(mnemonic);
      wallet['wav'] = {address:seed.address,privateKey:mnemonic}

      //neo
      const bip44path = `m/44'/888'/0'/0/0`;
      const actualSeed = await bip39.mnemonicToSeed(mnemonic);
      const rootNode = bitcoinSecp256r1.HDNode.fromSeedBuffer(actualSeed, bitcoinSecp256r1.bitcoin);

      const pathNode = rootNode.derivePath(bip44path);
      const pathNodeChild0 = pathNode.derive(0);
      const wif = pathNodeChild0.keyPair.toWIF();
      let account = new NeonWallet.Account(wif);
      address = account.address;
      wallet['neo'] = {address,privateKey:wif}

      console.log({wallet})
      done(wallet)
    }
    catch(err){
      console.log({err})
      done(err);
    }
  }
}
